<template>
  <div class="wrapper">
    <div class="bg-card">
      <div class="d-flex justify-content-between">
        <strong>{{ $t('pages.user-cv.document.title', 'Document') }}</strong>
        <b-button
          class="cv-button"
          @click="$emit('documentModalOpen')"
        >
          {{ $t('pages.user-cv.document.edit-button', 'Edit document') }}
        </b-button>
      </div>
      <hr>
      <div>
        <div v-if="document">
          <div>{{ $t('pages.user-cv.document.current-cv-document', 'Your current CV document') }}</div>
          <div
            class="document-download"
            @click="showCV"
          >
            <font-awesome-icon
              icon="download"
            />
            {{ document.document }}
          </div>
          <div>
            <font-awesome-icon
              icon="clock"
            />
            {{ $t('pages.user-cv.document.last-updated', 'Last update on:') }} {{ document.created_at }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    document: {
      type: Object,
      default: null
    }
  },
  methods: {
    showCV() {
      window.open(process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH + 'uploads/cv_v2/' + this.document.document);
    }
  }
}
</script>

